import request from '@/utils/request';
import requestNew from '@/utils/request-new';

//消息列表
export function getNewsTableData(data){
    //消息列表
    return request({
        url: '/notification/getList.do',
        method: 'post',
        data
    })
}

export function updateNewsRead(data){
    //查看已读
    return request({
        url: '/notification/updateStatus.do',
        method: 'post',
        data
    })
}

export function navNewsRead(data){
    //导航已读
    return requestNew({
        url: '/notification/getListByShow.do',
        method: 'post',
        data
    })
}

export function navNewsUnread(data){
    //导航未读
    return requestNew({
        url: '/notification/getListByNotShow.do',
        method: 'post',
        data
    })
}

//消息群发
export function getSendTableData(data){
    //群发记录
    return request({
        url: '/notification/selectMessList.do',
        method: 'post',
        data
    })
}

export function getUserList(data){
    //人员下拉
    return request({
        url: '/notification/selectMessUser.do',
        method: 'post',
        data
    })
}

export function sendMessage(data){
    //群发消息保存
    return request({
        url: '/notification/addMessageMass.do',
        method: 'post',
        data
    })
}

export function deleteSendMessageRecord(data){
    //消息列表中 按照插入批次删除
    return request({
        url: '/notification/deleteMessageMass.do',
        method: 'post',
        data
    })
}


// _ _ _ _

export function getAllNotificationByPage(data){
    //消息通知列表接口
    return request({
        url: '/teamnotification/getAllNotificationByPage.do',
        method: 'post',
        data
    })
}

export function batchUpdateTeammessageStatus(data){
    //消息通知批量已读
    return request({
        url: '/notification/batchUpdateTeammessageStatus.do',
        method: 'post',
        data
    })
}


export function uploadTrueOrFalse(data){
    //获取有效数据或无效数据
    return request({
        url: '/notification/uploadTrueOrFalse.do',
        method: 'post',
        data
    })
}

export function sureUploadAndSend(data){
    //确认发送
    return request({
        url: '/notification/sureUploadAndSend.do',
        method: 'post',
        data
    })
}

export function notUploadAndSend(data){
    //取消发送
    return request({
        url: '/notification/notUploadAndSend.do',
        method: 'post',
        data
    })
}

export function downError(data){
    //导出错误数据
    return request({
        url: '/notification/downError.do',
        method: 'post',
        data
    })
}
export function getJournalismList(data){
    //新闻列表
    return request({
        url: '/leyeJournalism/journalismList',
        method: 'get',
        data,
        formData:true
    })
}
export function getJournalismDesc(data){
    //新闻字典
    return request({
        url: '/dictionary/getJournalismDesc',
        method: 'get',
        data,
        formData:true
    })
}
export function saveOrUpdate(data){
    //保存新闻
    return request({
        url: '/leyeJournalism/saveOrUpdate',
        method: 'post',
        data
    })
}
export function getJournalismView(data){
    //编辑/预览新闻
    return request({
        url: '/leyeJournalism/getJournalismView',
        method: 'get',
        data,
        formData:true
    })
}
export function deleteJournalism(data){
    //删除新闻
    return request({
        url: '/leyeJournalism/deleteJournalism',
        method: 'post',
        data
    })
}